/** One grouped set of personal preference panes for the page and modal layouts. */
import {Suspense} from 'react';
import type {User} from '../../types/auth';
import {SettingsSingleColumn} from '../settings/settingsPrimitives';
import {SECTION_COMPONENTS} from './sectionComponents';
import {getSettingsTab, type SettingsTabId} from './settingsTabs';
export function PreferenceTabPanes({tab, user, singleColumn = false}: {tab: SettingsTabId; user: User; singleColumn?: boolean}) {
  const panes = <div className="flex flex-col gap-8">
    {getSettingsTab(tab).sections.map(id => {
      const Section = SECTION_COMPONENTS[id];
      return <section key={id} data-preference-section={id}><Suspense fallback={<div role="status" aria-label="Loading settings" className="h-[180px] rounded-2xl bg-muted/20"/>}><Section user={user}/></Suspense></section>;
    })}
  </div>;
  return singleColumn ? <SettingsSingleColumn>{panes}</SettingsSingleColumn> : panes;
}
